

angular
.module('inkfinder')
.factory('FormatAppointment', function FormatAppointment(
  moment,
  Payments,
  PREFERRED_TIME,
  STATUS_IDS,
  STATUS,
  _
) {
  // Public methods
  FormatAppointment.formatCollection = formatCollection;
  FormatAppointment.format = format;

  /**
   * @name formatCollection
   * @description Formats an array of appointments
   * @param {array} appointments The array of appointments to format.
   * @return {array} formatted Returns an array of formatted appointments.
   */
  function formatCollection(appointments) {
    let formatted = _.each(appointments, function(appointment) {
      return format(appointment);
    });
    return formatted;
  }

  /**
   * @name format
   * @description Formats an appointment.
   * @param {object} appointment The appointment to format.
   * @return {object} formatted Returns the formatted appointment.
   */
  function format(appointment) {
    let formatted = appointment;

    // Appointment preferred time
    formatted.preferredTime = _.find(PREFERRED_TIME, function(time) {
      if (appointment.preferred_time === time.id) {
        return true;
      }
    });

    // Appointment datetime formatting
    if (appointment.appointment_datetime !== null) {
      formatted.date = moment(appointment.appointment_datetime);
      formatted.calendarTime = moment(appointment.appointment_datetime,
        'YYYY-MM-DDTHH:mm:ss').calendar(null, {
          lastDay: '[Yesterday]',
          sameDay: '[Today]',
          nextDay: '[Tomorrow]',
          lastWeek: '[last] dddd',
          nextWeek: 'dddd',
          sameElse: 'L'
        });
      formatted.startTime = moment(appointment.appointment_datetime,
        'YYYY-MM-DDTHH:mm:ss').format('h:mm a');
      formatted.start = moment(appointment.appointment_datetime);
      formatted.startTimecode = moment(appointment.appointment_datetime).unix();
      formatted.endTime = moment(appointment.end_date,
        'YYYY-MM-DDTHH:mm:ss').format('h:mm a');
      formatted.end = moment(appointment.end_date);

      // Determine if Appointment has occured yet.
      if (moment(appointment.appointment_datetime) > moment()) {
        formatted.isPast = true;
      } else {
        formatted.isPast = false;
      }
    }

    // Appointment duration
    if (appointment.length) {
      formatted.durationHours =
      moment.duration(appointment.length).hours();
      formatted.durationMinutes =
      moment.duration(appointment.length).minutes();
      formatted.duration = moment(appointment.end_date)
        .diff(formatted.date, 'minutes');
    }

    // Payments formatting
    if (appointment.previously_paid === true) {
      formatted.outstandingBalance = false;
    } else if (appointment.price === null) {
      formatted.outstandingBalance = true;
    } else {
      let outstandingBalance = appointment.price;
      for (let k = 0; k < appointment.payments.length; k++) {
        let payment = appointment.payments[k];
        if (payment.status === 1) {
          outstandingBalance -= payment.amount;
        }
      }
      formatted.outstandingBalance = (outstandingBalance > 0);
    }

    // Deposits
    if (formatted.deposit_amount > 0) {
      formatted.deposit_required = true;
    } else {
      formatted.deposit_required = false;
    }

    // appointment.status is an array
    let allStatus = _.sortBy(appointment.status, 'created').reverse();
    formatted.last_status = allStatus[0];
    // Set if this appointment is ready to archive. When an appointment has reached
    // confirmed status or higher, it is no longer ready to archive.
    if (formatted.last_status.status_id === STATUS_IDS.requested ||
        formatted.last_status.status_id === STATUS_IDS.requestDeclined ||
        formatted.last_status.status_id === STATUS_IDS.expired ||
        formatted.last_status.status_id === STATUS_IDS.unconfirmed ||
        formatted.last_status.status_id === STATUS_IDS.declined) {
      formatted.archiveReady = true;
    } else {
      formatted.archiveReady = false;
    }

    // Parse all appointment payments
    Payments.process(appointment).then(function(paymentData) {
      formatted.paymentData = paymentData;

      // Payment status tooltips
      if (formatted.deposit_amount &&
      formatted.paymentData.depositTotal >= formatted.deposit_amount) {
        formatted.paymentToolTip = 'Deposit paid';
      } else if (formatted.previously_paid) {
        formatted.paymentToolTip = 'Previously paid';
      } else {
        formatted.paymentToolTip = 'Deposit not paid';
      }

      // Tooltips for all other statuses
      if (formatted.last_status.status_id === STATUS_IDS.confirmed) {
        formatted.statusToolTip = 'Appointment confirmed';
      } else if (formatted.last_status.status_id === STATUS_IDS.declined) {
        formatted.statusToolTip = 'Declined by the client';
      } else if (formatted.last_status.status_id ===
      STATUS_IDS.requestDeclined) {
        formatted.statusToolTip = 'Declined by the artist';
      } else if (formatted.last_status.status_id ===
      STATUS_IDS.collectorCancelled) {
        formatted.statusToolTip = 'Cancelled by the client';
      } else if (formatted.last_status.status_id ===
      STATUS_IDS.artistCancelled) {
        formatted.statusToolTip = 'Cancelled by the artist';
      } else if (formatted.last_status.status_id === STATUS_IDS.completed) {
        formatted.statusToolTip = 'Complete';
      }
    });

    // Set status names to more friendly terms
    formatted.last_status.label =
    STATUS[_.camelCase(formatted.last_status.status_name)];

    // Set overlapping variable to false
    formatted.overlappingAppt = false;

    // Set appt overlapping level
    formatted.apptLevel = 0;

    return formatted;
  }
  return FormatAppointment;
});



// WEBPACK FOOTER //
// ./components/appointments/util/format-appointments.service.js